import { useH5Mock } from "../global/GlobalMock";
import { post } from "../utils/Backend";

export type MiniappPayChannelConfig = {
  wechatAndroidPayEnabled: boolean;
  wechatIosPayEnabled: boolean;
  douyinAndroidPayEnabled: boolean;
  douyinIosPayEnabled: boolean;
};

const DEFAULT_CONFIG: MiniappPayChannelConfig = {
  wechatAndroidPayEnabled: true,
  wechatIosPayEnabled: true,
  douyinAndroidPayEnabled: true,
  douyinIosPayEnabled: true,
};

const mockPayChannel = false;

function normalize(res: Partial<MiniappPayChannelConfig> | null | undefined): MiniappPayChannelConfig {
  return {
    wechatAndroidPayEnabled: res?.wechatAndroidPayEnabled !== false,
    wechatIosPayEnabled: res?.wechatIosPayEnabled !== false,
    douyinAndroidPayEnabled: res?.douyinAndroidPayEnabled !== false,
    douyinIosPayEnabled: res?.douyinIosPayEnabled !== false,
  };
}

export const MiniappPayChannelApi = {
  async getConfig(): Promise<MiniappPayChannelConfig> {
    if (useH5Mock && mockPayChannel) {
      return { ...DEFAULT_CONFIG };
    }
    const res = await post<Record<string, never>, MiniappPayChannelConfig>(
      "/lark/app/miniapp/payChannel/getConfig",
      {},
      { silent: true }
    );
    if (typeof res === "string" || res == null) {
      return { ...DEFAULT_CONFIG };
    }
    return normalize(res);
  },
};
